import { EdgeMarkChannelReadRepository } from '@/modules/connect/infra'
import type { MarkChannelRead } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeMarkChannelRead(): MarkChannelRead {
  return new EdgeMarkChannelReadRepository(makeSupabaseEdgeHttpClient()).execute
}
